import React, { useEffect } from "react";

import { fetchMacroCodes } from "shared/actions/sysActions";
import { useHasLoaded, useIsLoading } from "shared/hooks/requestStatusHooks";

import AppSpinner from "AppSpinner";
import { useAppDispatch, useAppSelector } from "store/hooks";

const MacroCodeGate = ({ children }: { children: React.ReactNode }) => {
  const dispatch = useAppDispatch();
  const macroCodesEnabled = useAppSelector(
    ({ auth }) => auth.user?.userprofile?.enable_macro_helpers
  );

  if (macroCodesEnabled === undefined)
    throw new Error("User must be loaded before MacroCodeGate is rendered");

  const loadedMacroCodes = useHasLoaded(fetchMacroCodes);
  const loadingMacroCodes = useIsLoading(fetchMacroCodes);

  useEffect(() => {
    if (macroCodesEnabled === true && !loadedMacroCodes && !loadingMacroCodes) {
      dispatch(fetchMacroCodes());
    }
  }, [macroCodesEnabled, loadedMacroCodes, loadingMacroCodes]);

  if (macroCodesEnabled === true && (loadingMacroCodes || !loadedMacroCodes))
    return (
      <AppSpinner className="MacroCodeGate">Loading Macro Codes...</AppSpinner>
    );

  return <>{children}</>;
};

export default MacroCodeGate;
